import { AuthStorage } from "utils/auth-storage";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveReportAccessLevel } from "redux/permission-reducer";
import { WarehouseServices } from "apis/Services/WarehouseService";
import TransferModal from "pages/warehouse-inventory/transfer-modal";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import RestoreIcon from "@mui/icons-material/Restore";
import EditOutlined from "@mui/icons-material/EditOutlined";
import {
  Button,
  Tag,
  Card,
  Skeleton,
  Empty,
  Dropdown,
  Tabs,
  Modal,
  Select,
  TreeSelect,
} from "antd";
import {
  CheckOutlined,
  PlusOutlined,
  SwapOutlined,
  EditOutlined as EditOutlinedAnt,
  DeleteOutlined,
} from "@ant-design/icons";
import LoadingComponent from "components/loading-component";
import { Block } from "@material-ui/icons";
import { ProjectServices } from "apis/Services/ProjectService";
import toast from "react-hot-toast";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import RequestedTransfersModal from "./requested-treansfers-modal";
import { useOutletContext } from "react-router-dom";
import styles from "./warehouse-dashboard.module.css";
import {
  buildToLocationFilterTreeData,
  matchesToLocationFilter,
} from "./location-filters";

export default function WarehouseTransfers() {
  const { getTransferRequestsCount } = useOutletContext();

  const { company_id, id } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const [accessLevel, setAccessLevel] = useState();
  const [hasGranularPermissions, setHasGranularPermissions] = useState(false);
  const [data, setData] = useState([]);
  const [drafts, setDrafts] = useState([]);
  const [materialOptions, setMaterialOptions] = useState([]);
  const [projectAddressMap, setProjectAddressMap] = useState({});
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [activeTab, setActiveTab] = useState("transfers");
  const [transferFilters, setTransferFilters] = useState({
    fromLocation: [],
    toLocation: {},
  });
  const [requestedTransferFilters, setRequestedTransferFilters] = useState({
    fromLocation: [],
    toLocation: {},
  });
  const [selectedFromLocationFilter, setSelectedFromLocationFilter] =
    useState(undefined);
  const [selectedToLocationFilter, setSelectedToLocationFilter] =
    useState(undefined);

  const [isTransferVisible, setIsTransferVisible] = useState(false);
  const [editingDraft, setEditingDraft] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");

  const [selectedItem, setSelectedItem] = useState(null);

  const [shouldReload, setShouldReload] = useState(false);

  const [requestedTransfers, setRequestedTransfers] = useState([]);
  const [transfersHistoryData, setTransfersHistoryData] = useState([]);
  const [requestedTransferModalVisible, setRequestedTransferModalVisible] =
    useState(false);
  const [isRequestedTransfersLoading, setIsRequestedTransfersLoading] =
    useState(false);

  const dispatch = useDispatch();

  function getMaterialOptions() {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getWarehouseItems(ReqObj)
      .then((res) => {
        setMaterialOptions(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getAccessLevel() {
    setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    WarehouseServices.inventoryPageAccessLevel(ReqObj)
      .then((res) => {
        setAccessLevel(parseInt(res.accessLevel));

        if (
          parseInt(res?.accessLevel) === 1 &&
          parseInt(res?.requestsGranularAccessLevel) === 3
        ) {
          setHasGranularPermissions(true);
        }

        if (parseInt(res?.accessLevel) > 0) {
          getData();
          getDrafts();
          getMaterialOptions();
          getTransferRequests();
          getTransferRequestsCount();

          // if (parseInt(res?.accessLevel > 1)) {
          // }
        } else {
          setisLoading(false);
        }
        dispatch(saveReportAccessLevel(res.accessLevel));
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getProjectsAddress() {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getJobSites(ReqObj)
      .then((res) => {
        if (res) {
          const map = res.reduce((acc, item) => {
            acc[item.name] = item.address;
            return acc;
          }, {});

          setProjectAddressMap(map);
        }
        // setisLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getData() {
    // setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.transferHistoryInventory(ReqObj)
      .then((res) => {
        setData(
          Array.isArray(res)
            ? res
            : Array.isArray(res?.transfersHistory)
              ? res.transfersHistory
              : [],
        );
        setTransferFilters({
          fromLocation: Array.isArray(res?.filters?.fromLocation)
            ? res.filters.fromLocation
            : [],
          toLocation:
            res?.filters?.toLocation &&
            typeof res.filters.toLocation === "object"
              ? res.filters.toLocation
              : {},
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setisLoading(false));
  }

  function getDrafts() {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };

    WarehouseServices.getTransferDrafts(ReqObj)
      .then((res) => {
        setDrafts(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getTransferRequests() {
    setIsRequestedTransfersLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getTransferRequests(ReqObj)
      .then((res) => {
        setRequestedTransfers(res?.transfersHistory?.pending);
        setTransfersHistoryData(res?.transfersHistory?.history);
        setRequestedTransferFilters({
          fromLocation: Array.isArray(res?.filters?.fromLocation)
            ? res.filters.fromLocation
            : [],
          toLocation:
            res?.filters?.toLocation &&
            typeof res.filters.toLocation === "object"
              ? res.filters.toLocation
              : {},
        });
        console.log(res, "transfer requests!!");
        setIsRequestedTransfersLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setRequestedTransferFilters({
          fromLocation: [],
          toLocation: {},
        });
        setIsRequestedTransfersLoading(false);
      });
    // .finally(() => setisLoading(false));
  }

  const handleUpdateTransfer = (transfer) => {
    console.log("Updating transfer:", transfer);

    if (
      transfer.currentStatus !== "Delivered" &&
      transfer.cancelledStatus === ""
    ) {
      let code = AuthStorage.getItem("token");
      let email = AuthStorage.getItem("email");
      let ReqObj = {
        company: company_id,
        project: id,
        code,
        loginEmail: email,
        itemID: transfer.transferID,
        status: transfer.currentStatus === "Pending" ? "Transit" : "Delivered",
      };
      WarehouseServices.updateTransferInventoryItem(ReqObj)
        .then((res) => {
          toast.success("Status updated successfully");
          getData();
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong, please try again.");
        });
    }
    // Add your API call here to update the transfer status
    // After successful update, call setShouldReload(true) to refresh data
  };

  const submitTransferDrafts = (values) => {
    const transformedValues = {
      fromLocation: values.fromLocation,
      toLocation: values.toLocation,
      toLocationID: values.toLocationID,
      note: values.note || "",
      toSubLocation: values.toSubLocation || "",
      transferID: values.transferID,
      transferType: values.transferType || "transfer",
      items: values.items.map((item) => ({
        itemID: item.itemID,
        quantity: item.quantity.toString(),
      })),
    };

    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
      values: [transformedValues],
    };
    WarehouseServices.submitTransferDrafts(ReqObj)
      .then((res) => {
        toast.success("Transfer submitted successfully");
        getData();
        getDrafts();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.");
      });
  };

  const handleCancelTransfer = (transfer) => {
    console.log("Cancelling transfer:", transfer);

    if (
      transfer.currentStatus !== "Delivered" &&
      transfer.cancelledStatus === ""
    ) {
      let code = AuthStorage.getItem("token");
      let email = AuthStorage.getItem("email");
      let ReqObj = {
        company: company_id,
        project: id,
        code,
        loginEmail: email,
        itemID: transfer.transferID,
        status: "Cancelled",
      };
      WarehouseServices.updateTransferInventoryItem(ReqObj)
        .then((res) => {
          toast.success("Status updated successfully");
          getData();
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong, please try again.");
        });
    }
    // Add your API call here to cancel the transfer
    // After successful cancellation, call setShouldReload(true) to refresh data
  };

  const handleEditDraft = (draft) => {
    setEditingDraft(null); // reset previous draft to force re-render
    setTimeout(() => {
      setEditingDraft(draft);
      setIsTransferVisible(true);
    }, 0);
  };

  const handleDeleteDraft = (draft) => {
    Modal.confirm({
      title: "Delete Draft",
      content: "Are you sure you want to delete this draft transfer?",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () => {
        let code = AuthStorage.getItem("token");
        let email = AuthStorage.getItem("email");
        let ReqObj = {
          company: company_id,
          code,
          loginEmail: email,
          transferID: draft.transferID,
        };

        WarehouseServices.deleteTransferDrafts(ReqObj)
          .then((res) => {
            toast.success("Draft deleted successfully");
            getDrafts();
          })
          .catch((err) => {
            console.log(err);
            toast.error("Failed to delete draft");
          });
      },
    });
  };

  const handleSaveDraft = async (draftData) => {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
      values: draftData,
    };

    // TODO: Replace with actual API endpoint
    // return WarehouseServices.saveDraft(ReqObj);

    // Placeholder - remove when API is ready
    console.log("Save draft:", draftData);
    return Promise.resolve();
  };

  const canUpdate = (transfer) => {
    return (
      transfer.currentStatus === "Pending" ||
      transfer.currentStatus === "In Transit"
    );
  };

  const canCancel = (transfer) => {
    return (
      transfer.currentStatus !== "Delivered" &&
      transfer.currentStatus !== "Cancelled"
    );
  };

  // Filter data based on selected filter and search query
  const filteredData = data.filter((item) => {
    // First apply status filter
    let statusMatch = true;
    if (selectedFilter !== "All") {
      // Handle "In-Transit" filter matching "Transit" status
      if (selectedFilter === "Transit") {
        statusMatch = item.currentStatus === "Transit";
      } else {
        statusMatch = item.currentStatus === selectedFilter;
      }
    }

    // Then apply search filter
    let searchMatch = true;
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();

      // Search in material names and SKUs
      const itemMatch = item.items.some(
        (material) =>
          material.materialName?.toLowerCase().includes(query) ||
          material.sku?.toLowerCase().includes(query) ||
          material.itemVendor?.toLowerCase().includes(query) ||
          material.category?.toLowerCase().includes(query) ||
          material.subcategory?.toLowerCase().includes(query),
      );

      // Search in location/address
      const locationMatch = item.toLocation?.toLowerCase().includes(query);
      const addressMatch = projectAddressMap[item.toLocation]
        ?.toLowerCase()
        .includes(query);

      searchMatch = itemMatch || locationMatch || addressMatch;
    }

    const fromLocationMatch = selectedFromLocationFilter
      ? item.fromLocation === selectedFromLocationFilter
      : true;

    const toLocationMatch = matchesToLocationFilter(
      item,
      selectedToLocationFilter,
    );

    return statusMatch && searchMatch && fromLocationMatch && toLocationMatch;
  });

  // Filter drafts based on search query
  const filteredDrafts = drafts.filter((draft) => {
    if (!searchQuery.trim()) return true;

    const query = searchQuery.toLowerCase().trim();

    // Search in material names and SKUs
    const itemMatch = draft.items?.some(
      (material) =>
        material.materialName?.toLowerCase().includes(query) ||
        material.sku?.toLowerCase().includes(query) ||
        material.itemVendor?.toLowerCase().includes(query),
    );

    // Search in location
    const locationMatch = draft.toLocation?.toLowerCase().includes(query);

    return itemMatch || locationMatch;
  });

  // Filter buttons configuration
  const filterButtons = [
    { key: "All", label: "All" },
    { key: "Pending", label: "Pending" },
    { key: "In Transit", label: "In Transit" },
    { key: "Delivered", label: "Delivered" },
    { key: "Cancelled", label: "Cancelled" },
  ];

  const fromLocationOptions = transferFilters.fromLocation.map((location) => ({
    label: location,
    value: location,
  }));

  const toLocationTreeData = buildToLocationFilterTreeData(
    transferFilters.toLocation,
  );

  useEffect(() => {
    getAccessLevel();
    getProjectsAddress();
  }, []);

  useEffect(() => {
    if (shouldReload) {
      getData();
      getDrafts();
      getMaterialOptions();
      setShouldReload(false);
    }
  }, [shouldReload]);

  const handleAddNew = () => {
    setSelectedItem();
    setEditingDraft(null);
    setIsTransferVisible(true);
  };

  const renderNewTransferButton = () => {
    if (accessLevel > 1) {
      return (
        <Button
          type="primary"
          size="large"
          onClick={handleAddNew}
        >
          <PlusOutlined /> New Transfer
        </Button>
      );
    }

    return (
      <Button
        type="primary"
        onClick={handleAddNew}
        size="large"
        disabled={accessLevel < 2 && !hasGranularPermissions}
      >
        <PlusOutlined /> Request New Transfer
      </Button>
    );
  };

  const items = [
    {
      key: "cancel",
      icon: <Block />,
      label: "Cancel Transfer",
      danger: true,
      // onClick: () => handleCancelTransfer(transfer),
    },
  ];

  const draftMenuItems = (draft) => [
    {
      key: "edit",
      icon: <EditOutlinedAnt />,
      label: "Edit Draft",
      onClick: () => handleEditDraft(draft),
    },
    {
      key: "delete",
      icon: <DeleteOutlined />,
      label: "Delete Draft",
      danger: true,
      onClick: () => handleDeleteDraft(draft),
    },
  ];

  const statusColors = {
    Pending: "orange",
    "In Transit": "blue",
    Transit: "blue",
    Delivered: "green",
    Cancelled: "red",
    Draft: "default",
  };
  const renderTransferCard = (transfer) => (
    <div
      className=" d-flex justify-content-center w-100"
      key={transfer.transferID}
    >
      <Card
        className=" w-100  bg-light bg-opacity-50"
        title={
          <div className="pt-3 pb-1">
            <div className="d-flex flex-column flex-lg-row justify-content-between mb-2 align-items-center gap-3">
              {/* Left side - Transfer ID and Status */}
              <div className="d-flex align-items-center  mb-3 mb-lg-0 ">
                <Tag
                  className="flex items-center justify-center align-items-center fw-bold"
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  color={statusColors[transfer.currentStatus] || "default"}
                >
                  {transfer.currentStatus === "Pending" && (
                    <RestoreIcon
                      style={{
                        color: statusColors[transfer.currentStatus],
                        fontSize: "1.7rem",
                      }}
                    />
                  )}

                  {transfer.currentStatus === "In Transit" && (
                    <LocalShippingOutlinedIcon
                      style={{
                        color: statusColors[transfer.currentStatus],
                      }}
                    />
                  )}

                  {transfer.currentStatus === "Delivered" && (
                    <Inventory2OutlinedIcon
                      style={{
                        color: statusColors[transfer.currentStatus],
                      }}
                    />
                  )}

                  {transfer.currentStatus === "Cancelled" && (
                    <Block
                      style={{
                        color: statusColors[transfer.currentStatus],
                        fontSize: "1.7rem",
                      }}
                    />
                  )}
                </Tag>

                <div className="d-flex flex-column justify-content-start gap-0">
                  <div>
                    <h5 className="fw-bold m-0 p-0">
                      Transfer #{transfer.transferID}
                    </h5>
                  </div>
                  <div>
                    <Tag
                      color={statusColors[transfer.currentStatus] || "default"}
                      bordered={false}
                      className="rounded-5"
                    >
                      {transfer.currentStatus}
                    </Tag>
                  </div>
                </div>
              </div>

              {/* Right side  */}
              <div className="d-flex flex-column flex-md-row gap-3 gap-md-5 justify-content-start justify-content-md-end align-items-start align-items-md-center">
                <div
                  className="d-flex flex-column text-end"
                  style={{
                    fontSize: "0.85rem",
                    color: "#888",
                    fontWeight: "normal",
                    alignItems: "flex-end",
                  }}
                >
                  <span className="fw-bold fs-4">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(transfer.totalTransferValue)}
                  </span>
                  <span>{transfer.createdAt}</span>
                </div>
              </div>
            </div>
          </div>
        }
        style={{ marginBottom: 16 }}
      >
        <div className=" d-flex justify-content-center align-items-center flex-column">
          <div className=" d-flex w-100 justify-content-md-start align-self-start flex-wrap gap-3 justify-content-start py-3">
            <div>
              {transfer.items.map((item, index) => (
                <div key={index}>
                  <div
                    className="d-flex flex-wrap justify-content-start px-3 py-2"
                    style={{
                      columnGap: "3rem",
                      rowGap: "1rem",
                    }}
                  >
                    {/* Material Info */}
                    <div
                      className="d-md-flex flex-md-row gap-2 align-items-center"
                      style={{ minWidth: "220px" }}
                    >
                      <Inventory2OutlinedIcon
                        style={{ fontSize: "1.3rem" }}
                        className="opacity-50"
                      />
                      <div className="d-flex flex-column text-start">
                        <small
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1.2",
                            fontWeight: "bold",
                          }}
                        >
                          {item.materialName}
                        </small>
                        <small
                          className="opacity-50"
                          style={{
                            fontSize: "0.9rem",
                            lineHeight: "1.2",
                          }}
                        >
                          SKU: {item.sku}
                        </small>
                        {item?.itemVendor ? (
                          <small
                            className="opacity-50"
                            style={{
                              fontSize: "0.9rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Vendor: {item.itemVendor}
                          </small>
                        ) : null}
                        <small
                          style={{
                            fontSize: "0.9rem",
                            lineHeight: "1.2",
                          }}
                        >
                          {item.category}
                        </small>
                        <small
                          style={{
                            fontSize: "0.9rem",
                            lineHeight: "1.2",
                          }}
                        >
                          {item.subcategory}
                        </small>
                      </div>
                    </div>

                    {/* Location Info */}
                    <div
                      className="d-md-flex flex-md-row gap-2 align-items-center"
                      style={{ minWidth: "220px" }}
                    >
                      <LocationOnOutlinedIcon
                        style={{ fontSize: "1.3rem" }}
                        className="opacity-50"
                      />
                      <div className="d-flex flex-column text-start">
                        <small
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1.2",
                            fontWeight: "bold",
                          }}
                        >
                          {transfer.toLocation}
                        </small>
                        <small
                          className="opacity-75"
                          style={{
                            fontSize: "0.9rem",
                            lineHeight: "1.2",
                          }}
                        >
                          {Object.keys(projectAddressMap).length > 0 ? (
                            projectAddressMap[transfer.toLocation] || ""
                          ) : (
                            <Skeleton.Input
                              style={{ width: 100, height: 15 }}
                              active
                              size="small"
                            />
                          )}
                        </small>
                        <small
                          style={{
                            fontSize: "0.9rem",
                            lineHeight: "1.2",
                          }}
                        >
                          {transfer.toSubLocation}
                        </small>
                      </div>
                    </div>

                    <div
                      className="d-md-flex flex-md-row gap-2 align-items-center"
                      style={{ minWidth: "100px" }}
                    >
                      {/* Quantity Info */}
                      <div className="text-center text-md-end">
                        <small
                          className="fw-bold"
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1",
                          }}
                        >
                          Quantity
                        </small>
                        <h4
                          style={{
                            color: "#1777FF",
                            fontWeight: "bold",
                            lineHeight: "1",
                            margin: 0,
                          }}
                        >
                          {item.quantity} {item.quantity > 1 ? "units" : "unit"}
                        </h4>
                      </div>
                    </div>

                    {/* Amount Info */}
                    <div
                      className="d-md-flex flex-md-column gap-2 align-items-center"
                      style={{ minWidth: "100px" }}
                    >
                      <small
                        className="fw-bold"
                        style={{
                          fontSize: "1rem",
                          lineHeight: "1",
                        }}
                      >
                        Amount
                      </small>
                      <h4
                        style={{
                          fontWeight: "bold",
                          lineHeight: "1",
                          margin: 0,
                        }}
                        className="opacity-50"
                      >
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(item.unitPrice * item.quantity)}
                      </h4>
                    </div>
                  </div>

                  {/* Add hr except after the last item */}
                  {index < transfer.items.length - 1 && <hr className="my-2" />}
                </div>
              ))}
            </div>
          </div>
          <hr className=" w-100" />
          <div className=" d-flex justify-content-between align-items-center w-100">
            <div className="">
              <strong className=" opacity-75">Notes</strong>
              <br />
              <i>{transfer.note || ""}</i>
            </div>
            <div>
              {transfer.currentStatus === "Delivered" && (
                <div className="d-flex align-items-center gap-1 text-success">
                  <CheckOutlined
                    className="opacity-75"
                    style={{ fontSize: "1rem" }}
                  />
                  <strong>Delivered</strong>
                </div>
              )}
              {transfer.currentStatus === "Cancelled" && (
                <div className="d-flex align-items-center gap-1 text-danger">
                  <Block className="opacity-75" style={{ fontSize: "1rem" }} />
                  <strong>Cancelled</strong>
                </div>
              )}
              {canCancel(transfer) &&
                canUpdate(transfer) &&
                accessLevel > 1 && (
                  <div>
                    <Dropdown.Button
                      type="default"
                      menu={{
                        items,
                        onClick: ({ key }) =>
                          handleCancelTransfer(transfer, key),
                      }}
                      onClick={() => handleUpdateTransfer(transfer)}
                    >
                      {transfer.currentStatus === "Pending" && (
                        <div className="d-flex align-items-center gap-1">
                          <LocalShippingOutlinedIcon
                            className="opacity-50"
                            style={{ fontSize: "1.2rem" }}
                          />
                          <span>Ship</span>
                        </div>
                      )}

                      {transfer.currentStatus === "In Transit" && (
                        <div className="d-flex align-items-center gap-1">
                          <span>Mark Delivered</span>
                        </div>
                      )}
                    </Dropdown.Button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  const renderDraftCard = (draft) => (
    <div className=" d-flex justify-content-center w-100" key={draft.id}>
      <Card
        className=" w-100  bg-light bg-opacity-50"
        title={
          <div className="pt-3 pb-1">
            <div className="d-flex flex-column flex-lg-row justify-content-between mb-2 align-items-center gap-3">
              {/* Left side - Draft info */}
              <div className="d-flex align-items-center  mb-3 mb-lg-0 ">
                <Tag
                  className="flex items-center justify-center align-items-center fw-bold"
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  color="default"
                >
                  <EditOutlined style={{ fontSize: "1.7rem" }} />
                </Tag>

                <div className="d-flex flex-column justify-content-start gap-0">
                  <div>
                    <h5 className="fw-bold m-0 p-0">
                      Draft #{draft.transferID}
                    </h5>
                  </div>
                  <div>
                    <Tag bordered={false} className="rounded-5">
                      Draft
                    </Tag>
                  </div>
                </div>
              </div>

              {/* Right side  */}
              <div className="d-flex flex-column flex-md-row gap-3 gap-md-5 justify-content-start justify-content-md-end align-items-start align-items-md-center">
                <div
                  className="d-flex flex-column text-end"
                  style={{
                    fontSize: "0.85rem",
                    color: "#888",
                    fontWeight: "normal",
                    alignItems: "flex-end",
                  }}
                >
                  {/* <span className="fw-bold fs-4">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(draft.totalTransferValue)}
                  </span> */}
                  <span>{draft.createdAt}</span>
                </div>
              </div>
            </div>
          </div>
        }
        style={{ marginBottom: 16 }}
      >
        <div className=" d-flex justify-content-center align-items-center flex-column">
          <div className=" d-flex w-100 justify-content-md-start align-self-start flex-wrap gap-3 justify-content-start py-3">
            <div>
              {draft.items?.map((item, index) => (
                <div key={index}>
                  <div
                    className="d-flex flex-wrap justify-content-start px-3 py-2"
                    style={{
                      columnGap: "3rem",
                      rowGap: "1rem",
                    }}
                  >
                    {/* Material Info */}
                    <div
                      className="d-md-flex flex-md-row gap-2 align-items-center"
                      style={{ minWidth: "220px" }}
                    >
                      <Inventory2OutlinedIcon
                        style={{ fontSize: "1.3rem" }}
                        className="opacity-50"
                      />
                      <div className="d-flex flex-column text-start">
                        <small
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1.2",
                            fontWeight: "bold",
                          }}
                        >
                          {item.materialName || "Material"}
                        </small>
                        <small
                          className="opacity-50"
                          style={{
                            fontSize: "0.9rem",
                            lineHeight: "1.2",
                          }}
                        >
                          SKU: {item.sku || "N/A"}
                        </small>
                        {item?.itemVendor ? (
                          <small
                            className="opacity-50"
                            style={{
                              fontSize: "0.9rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Vendor: {item.itemVendor}
                          </small>
                        ) : null}
                      </div>
                    </div>

                    {/* Location Info */}
                    <div
                      className="d-md-flex flex-md-row gap-2 align-items-center"
                      style={{ minWidth: "220px" }}
                    >
                      <LocationOnOutlinedIcon
                        style={{ fontSize: "1.3rem" }}
                        className="opacity-50"
                      />
                      <div className="d-flex flex-column text-start">
                        <small
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1.2",
                            fontWeight: "bold",
                          }}
                        >
                          {draft.toLocation || "Location"}
                        </small>
                        {draft.toSubLocation && (
                          <small
                            style={{
                              fontSize: "0.9rem",
                              lineHeight: "1.2",
                            }}
                          >
                            {draft.toSubLocation}
                          </small>
                        )}
                      </div>
                    </div>

                    <div
                      className="d-md-flex flex-md-row gap-2 align-items-center"
                      style={{ minWidth: "100px" }}
                    >
                      {/* Quantity Info */}
                      <div className="text-center text-md-end">
                        <small
                          className="fw-bold"
                          style={{
                            fontSize: "1rem",
                            lineHeight: "1",
                          }}
                        >
                          Quantity
                        </small>
                        <h4
                          style={{
                            color: "#1777FF",
                            fontWeight: "bold",
                            lineHeight: "1",
                            margin: 0,
                          }}
                        >
                          {item.quantity} {item.quantity > 1 ? "units" : "unit"}
                        </h4>
                      </div>
                    </div>

                    <div
                      className="d-md-flex flex-md-column gap-2 align-items-center"
                      style={{ minWidth: "100px" }}
                    >
                      <small
                        className="fw-bold"
                        style={{
                          fontSize: "1rem",
                          lineHeight: "1",
                        }}
                      >
                        Amount
                      </small>
                      <h4
                        style={{
                          fontWeight: "bold",
                          lineHeight: "1",
                          margin: 0,
                        }}
                        className="opacity-50"
                      >
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format((item.unitPrice || 0) * (item.quantity || 0))}
                      </h4>
                    </div>
                  </div>

                  {/* Add hr except after the last item */}
                  {index < draft.items.length - 1 && <hr className="my-2" />}
                </div>
              ))}
            </div>
          </div>
          <hr className=" w-100" />
          <div className=" d-flex justify-content-between align-items-center w-100">
            <div className="">
              <strong className=" opacity-75">Notes</strong>
              <br />
              <i>{draft.note || ""}</i>
            </div>
            <div className="d-flex gap-2">
              <Button
                icon={<EditOutlinedAnt />}
                onClick={() => handleEditDraft(draft)}
              >
                Edit
              </Button>

              <Dropdown.Button
                type="primary"
                menu={{
                  items: [
                    {
                      key: "delete",
                      icon: <DeleteOutlined />,
                      label: "Delete Draft",
                      danger: true,
                    },
                  ],
                  onClick: ({ key }) => {
                    if (key === "delete") {
                      handleDeleteDraft(draft);
                    }
                  },
                }}
                onClick={() => submitTransferDrafts(draft)}
              >
                Submit Transfer
              </Dropdown.Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  return (
    <div className=" bg-white p-4 rounded-3 p-2 d-flex flex-column justify-content-center">
      {isLoading && (
        <div className="row d-flex justify-content-center">
          <LoadingComponent />
        </div>
      )}

      {!isLoading && accessLevel === 0 && (
        <div className="row w-100 d-flex justify-content-center p-5">
          {!isLoading && accessLevel === 0 && (
            <div className="row w-100 d-flex justify-content-center p-5">
              <div className="d-flex flex-column align-items-center text-center gap-3">
                <LockRoundedIcon style={{ fontSize: "5rem", color: "#999" }} />
                <h6 className="mt-2 mb-0 text-muted">
                  You do not have the necessary permissions to access this page.
                </h6>
              </div>
            </div>
          )}
        </div>
      )}

      {!isLoading && accessLevel > 0 && (
        <div
          className=" align-self-center  "
          style={{
            width: "85%",
          }}
        >
          <div className="row">
            <div>
              <h3 className="fw-bold p-0 m-0">Material Transfers</h3>
              <p className="opacity-75 mt-2 p-0">
                Track material movements between warehouse and job sites
              </p>
            </div>
          </div>

          <div className="row mt-2">
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              items={[
                {
                  key: "transfers",
                  label: "Transfers",
                  children: (
                    <>
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-3">
                        {/* Filter Buttons */}
                        <div className="d-flex gap-2 flex-wrap">
                          {filterButtons.map((filter) => (
                            <Button
                              key={filter.key}
                              type={
                                selectedFilter === filter.key
                                  ? "primary"
                                  : "default"
                              }
                              onClick={() => setSelectedFilter(filter.key)}
                              shape="round"
                            >
                              {filter.label}
                            </Button>
                          ))}
                        </div>

                        <div className=" d-flex gap-2">
                          {accessLevel > 1 && (
                            <Button
                              size="large"
                              type="default"
                              onClick={() =>
                                setRequestedTransferModalVisible(true)
                              }
                            >
                              Requested Transfers
                              {requestedTransfers?.length > 0 && (
                                <span
                                  style={{
                                    backgroundColor: "#1777FF",
                                    color: "#ffffff",
                                    borderRadius: "50%",
                                    padding: "0",
                                    fontSize: "12px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minWidth: "22px",
                                    height: "22px",
                                    fontWeight: "bold",
                                    lineHeight: "1",
                                  }}
                                >
                                  {requestedTransfers.length}
                                </span>
                              )}
                            </Button>
                          )}

                          {renderNewTransferButton()}
                        </div>
                      </div>

                      <div className="d-flex gap-3 flex-wrap mb-3">
                        <div style={{ minWidth: "240px", flex: "1 1 240px" }}>
                          <div
                            className="mb-2"
                            style={{
                              fontSize: "12px",
                              fontWeight: 600,
                              color: "#667085",
                            }}
                          >
                            From Location
                          </div>
                          <Select
                            allowClear
                            showSearch
                            size="large"
                            placeholder="All from locations"
                            value={selectedFromLocationFilter}
                            options={fromLocationOptions}
                            onChange={setSelectedFromLocationFilter}
                            style={{ width: "100%" }}
                            className={styles.pillSelect}
                            optionFilterProp="label"
                          />
                        </div>

                        <div style={{ minWidth: "300px", flex: "1 1 300px" }}>
                          <div
                            className="mb-2"
                            style={{
                              fontSize: "12px",
                              fontWeight: 600,
                              color: "#667085",
                            }}
                          >
                            To Location
                          </div>
                          <TreeSelect
                            allowClear
                            showSearch
                            size="large"
                            treeDefaultExpandAll
                            placeholder="All to locations"
                            value={selectedToLocationFilter}
                            treeData={toLocationTreeData}
                            onChange={setSelectedToLocationFilter}
                            style={{ width: "100%" }}
                            className={styles.pillSelect}
                            treeNodeFilterProp="title"
                          />
                        </div>
                      </div>

                      {/* Search Input */}
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control rounded rounded-5"
                          placeholder="Search by material name, SKU, category, subcategory or location..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{
                            padding: "10px 20px",
                            border: "1px solid #d9d9d9",
                          }}
                        />
                      </div>

                      {/* Show Empty component when no data */}
                      {filteredData.length === 0 ? (
                        <div className="d-flex justify-content-center w-100 my-5">
                          <Empty
                            image={
                              <SwapOutlined
                                style={{ fontSize: "4rem", color: "#d9d9d9" }}
                              />
                            }
                            imageStyle={{
                              height: 80,
                              marginBottom: 16,
                            }}
                            description={
                              <div>
                                <p
                                  className="mb-1"
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {selectedFilter === "All"
                                    ? "No transfers found"
                                    : `No ${selectedFilter.toLowerCase()} transfers found`}
                                </p>
                                <p
                                  className="mb-0 opacity-75"
                                  style={{ fontSize: "14px" }}
                                >
                                  {selectedFilter === "All"
                                    ? "Start by creating your first material transfer"
                                    : `No transfers with ${selectedFilter.toLowerCase()} status`}
                                </p>
                              </div>
                            }
                          >
                            {selectedFilter === "All" && (
                              <Button type="primary" onClick={handleAddNew}>
                                Create Transfer
                              </Button>
                            )}
                          </Empty>
                        </div>
                      ) : (
                        // Show transfer cards when data is available
                        filteredData.map((transfer) =>
                          renderTransferCard(transfer),
                        )
                      )}
                    </>
                  ),
                },
                {
                  key: "drafts",
                  label: (
                    <span>
                      Drafts
                      {/* {drafts.length > 0 && (
                        <Badge
                          count={drafts.length}
                          style={{ marginLeft: 8 }}
                        />
                      )} */}
                    </span>
                  ),
                  children: (
                    <>
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-3">
                        <div></div>
                        {renderNewTransferButton()}
                      </div>

                      {/* Search Input */}
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control rounded rounded-5"
                          placeholder="Search drafts by material name, SKU, or location..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{
                            padding: "10px 20px",
                            border: "1px solid #d9d9d9",
                          }}
                        />
                      </div>

                      {/* Show Empty component when no drafts */}
                      {filteredDrafts.length === 0 ? (
                        <div className="d-flex justify-content-center w-100 my-5">
                          <Empty
                            image={
                              <EditOutlinedAnt
                                style={{ fontSize: "4rem", color: "#d9d9d9" }}
                              />
                            }
                            imageStyle={{
                              height: 80,
                              marginBottom: 16,
                            }}
                            description={
                              <div>
                                <p
                                  className="mb-1"
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "500",
                                  }}
                                >
                                  No draft transfers found
                                </p>
                                <p
                                  className="mb-0 opacity-75"
                                  style={{ fontSize: "14px" }}
                                >
                                  Save transfers as drafts to continue working
                                  on them later
                                </p>
                              </div>
                            }
                          >
                            <Button type="primary" onClick={handleAddNew}>
                              Create Transfer
                            </Button>
                          </Empty>
                        </div>
                      ) : (
                        // Show draft cards when data is available
                        filteredDrafts.map((draft) => renderDraftCard(draft))
                      )}
                    </>
                  ),
                },
              ]}
            />
          </div>
        </div>
      )}

      <TransferModal
        isTransferVisible={isTransferVisible}
        setIsTransferVisible={setIsTransferVisible}
        materialsOptions={materialOptions}
        setShouldReload={setShouldReload}
        hasGranularPermissions={hasGranularPermissions}
        transferData={editingDraft}
        onSaveDraft={handleSaveDraft}
      />

      <RequestedTransfersModal
        requestedTransfers={requestedTransfers}
        requestedTransferModalVisible={requestedTransferModalVisible}
        setRequestedTransferModalVisible={setRequestedTransferModalVisible}
        projectID={id}
        accessLevel={accessLevel}
        transferFilters={requestedTransferFilters}
        getTransferRequests={getTransferRequests}
        isRequestedTransfersLoading={isRequestedTransfersLoading}
        getData={getData}
        transfersHistoryData={transfersHistoryData}
        getTransferRequestsCount={getTransferRequestsCount}
      />
    </div>
  );
}
